import clsx from 'clsx';
import { Skeleton } from './Skeleton';

interface SkeletonFieldsProps {
  count: number;
  /** Two columns for the detail forms (`grid-cols-2`), one for a stacked settings card. */
  columns?: 1 | 2;
}

/** Label-over-input pairs in the shape of an Ant vertical form. Not a region itself — it goes inside a skeleton that is. */
export function SkeletonFields({ count, columns = 1 }: SkeletonFieldsProps) {
  return (
    <div className={clsx('grid gap-x-3 gap-y-6', columns === 2 && 'grid-cols-2')}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="flex flex-col gap-2">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-8 w-full" />
        </div>
      ))}
    </div>
  );
}
